import { render, staticRenderFns } from "./reset-psw.vue?vue&type=template&id=55b411ac&scoped=true"
import script from "./reset-psw.vue?vue&type=script&lang=js"
export * from "./reset-psw.vue?vue&type=script&lang=js"
import style0 from "./reset-psw.vue?vue&type=style&index=0&id=55b411ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b411ac",
  null
  
)

export default component.exports